import React from 'react';
import { Box, Text, Grid, GridItem } from '@chakra-ui/react';
import commafy from 'commafy';

const formatAmount = (amount) => {
  if (amount == null || amount === '' || isNaN(parseFloat(amount))) {
    return '0.00';
  }
  return parseFloat(amount).toFixed(2);
};

const BalanceCards = ({ balance }) => {
  if (!balance) return null;

  return (
    <Grid templateColumns="repeat(2, 1fr)" gap="2rem" mb="2rem">
      <GridItem>
        <Box
          bg="white"
          p="2rem"
          borderRadius="8px"
          boxShadow="md"
          borderLeft="4px solid"
          borderLeftColor="brand.blue"
        >
          <Text fontSize="14px" fontFamily="medium" color="#808080" mb="1rem">
            Starting Balance
          </Text>
          <Text fontSize="32px" fontFamily="bold" color="brand.blue">
            ₦{commafy(formatAmount(balance.starting_balance))}
          </Text>
        </Box>
      </GridItem>
      <GridItem>
        <Box
          bg="white"
          p="2rem"
          borderRadius="8px"
          boxShadow="md"
          borderLeft="4px solid"
          borderLeftColor="#2EAE65"
        >
          <Text fontSize="14px" fontFamily="medium" color="#808080" mb="1rem">
            Ending Balance
          </Text>
          <Text fontSize="32px" fontFamily="bold" color="#2EAE65">
            ₦{commafy(formatAmount(balance.ending_balance))}
          </Text>
        </Box>
      </GridItem>
    </Grid>
  );
};

export { BalanceCards };
